import { MyCapitalKeys } from '../../models/mycapital/mycapital-model';
import { MyCapitalActions } from './mycapital.action';

  export interface IMyCapitalState {
    keys: MyCapitalKeys;
    keysHasValue: boolean;  
  }

  export const initialState: IMyCapitalState = {
    keys: null,
    keysHasValue: false,
  };

  export function MyCapitalReducer(
    state: IMyCapitalState,
    action: MyCapitalActions,
  ) {
    state = state || initialState;
    switch (action.type) {
      case MyCapitalActions.getMyCapitalKeys:
        return { ...state, keysHasValue: false };
    
      case MyCapitalActions.getMyCapitalKeysSuccess:
        return {
          ...state,
          keys: action.payload,
          keysHasValue: true,
        };
    
      case MyCapitalActions.getMyCapitalKeysError:
        return { ...state, keysHasValue: false };
  
      default:
        return state;
    }
  }
  